<template>
  <!-- Topbar -->
  <nav
    class="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow"
  >
    <!-- Page Heading -->
    <!-- <h1 class="h3 mb-2 text-gray-800">Tables</h1> -->
    <p class="mb-4"></p>

    <!-- Topbar Navbar -->
    <ul class="navbar-nav ml-auto">
      <div class="topbar-divider d-none d-sm-block"></div>

      <!-- Nav Item - User Information -->
      <li class="nav-item dropdown no-arrow">
        <!-- <a
          class="nav-link dropdown-toggle"
          href="#"
          id="userDropdown"
          role="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        > -->
        <router-link
          class="action-btn-new"
          :to="{ name: 'article-create' }"
          v-if="userPermissions.some((e) => [P_CREATE_ARTICLE].includes(e))"
        >
          <i class="fas fa-plus"></i> Nouvelle fiche
        </router-link>
        <!-- </a> -->
      </li>
    </ul>
  </nav>
</template>

<script>
import { mapGetters } from "vuex";
import { P_CREATE_ARTICLE } from "@/helpers/permissions";

export default {
  data() {
    return {
      P_CREATE_ARTICLE,
    };
  },
  computed: {
    ...mapGetters(["userPermissions"]),
  },
};
</script>